<template>
  <div class="container">
      <router-view v-if="true">
      </router-view>
  </div>
</template>

<script type="text/ecmascript-6">
import Index from '../index2.vue'
export default {
  name: '',
  mixins: [],
  components: {Index},
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  filters: {},
  mounted () { },
  created () { }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
